// @flow
import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import SubmitButton from '../../components/SubmitButton';
import { GreyTextReactLink } from '../../components/LinkStyles';
import { requiredField } from '../../utilities/validations';
import Input from '../../components/Input';
import { defaultSubmitHandler } from '../../utilities/requests';
import { history } from '../../utilities/history';
import { setSignInMessage } from '../SignIn/reducer';

type Props = {
  handleSubmit: (values: any) => void,
  error: ?string,
  submitting: boolean
};

class RequestReset extends Component<Props> {
  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <h1>Reset Password</h1>
        <Field
          type="email"
          label="Email"
          name="email"
          validate={requiredField}
          component={Input}
        />
        <SubmitButton
          value="Submit"
          error={this.props.error}
          disabled={this.props.submitting}
          marginTop="3rem"
        />
        <GreyTextReactLink to="/signin">Cancel</GreyTextReactLink>
      </form>
    );
  }
}

const onSubmitSuccess = (result, dispatch) => {
  history.push('/signin');
  dispatch(setSignInMessage('Email sent with password reset instructions'));
};

export default reduxForm({
  form: 'requestReset',
  onSubmit: defaultSubmitHandler('/password_resets'),
  onSubmitSuccess
})(RequestReset);
